import {
  titleCaseForString,
  trimJoinedStringWhitespace
} from '../../core/util';
import { maskSsnForDisplay } from '../PersonalInformationSection/util';

export const beneficiaryLine1 = bene => {
  return bene.percentage;
};

export const beneficiaryLine2 = bene => {
  if (typeof bene.name === 'string') {
    return bene.name;
  }
  const fullBeneName = `${bene.name.firstName} ${bene.name.middleName} ${bene.name.lastName}`;
  return trimJoinedStringWhitespace(fullBeneName);
};

export const beneficiaryLine3 = bene => {
  const str = [];
  if (bene.relationship) str.push(titleCaseForString(bene.relationship));
  if (bene.dateOfBirth) str.push(bene.dateOfBirth);
  str.push(typeof bene.name === 'string' ? 'Entity' : 'Person');
  if (bene.taxID) str.push(maskSsnForDisplay(bene.taxID));
  return str.join(' / ');
};
